import React from "react";
import "./OnlineCategories.scss";
import {useHistory} from "react-router-dom";



function OnlineCategories({cats,merchantId}) {
    //hooks
    const history = useHistory();

    return(
        <div className="online-categories-container">
            <div className="section-title">
                دسته بندی ها
            </div>
            <div className="categories-list">
                {cats && cats.map(item=>{
                    return(
                        <div className="categories-item" onClick={()=>{
                            history.push(`/dr-shop/search/${merchantId}/${item.uid}`)
                        }}>
                            <img src={item.image} alt=""/>
                            <span>{item.name}</span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export {OnlineCategories};
